{
  "en": {
    "subscriptions": {
      "plans": {
        "free": {
          "title": "Free account"
        },
        "courses": {
          "title": "Courses only",
          "subtitle": "Full access to all fobizz professional development courses.",
          "features": "<li><i class='bi bi-check-lg'></i><div>Access to the entire professional development catalog</div></li><li><i class='bi bi-check-lg'></i><div>Access to all webinar recordings</div></li><li><i class='bi bi-check-lg'></i><div>Practical exercises and materials included</div></li><li><i class='bi bi-check-lg'></i><div>All courses come with a certificate</div></li>"
        },
        "tools": {
          "title": "Tools only",
          "subtitle": "Unlimited access to fobizz tools and AI assistance for teaching.",
          "features": "<li><i class='bi bi-check-lg'></i><div>Unlimited use of all digital tools, including AI</div></li><li><i class='bi bi-check-lg'></i><div>Unlimited access to AI shared spaces</div></li><li><i class='bi bi-check-lg'></i><div>Unlimited creation of your own AI assistants and chatbots</div></li><li><i class='bi bi-check-lg'></i><div>No registration of students necessary</div></li>"
        },
        "combined": {
          "title": "Full plan",
          "subtitle": "All benefits of the training and tools license combined.",
          "badge": "Popular",
          "features": "<li><i class='bi bi-check-lg'></i><div>Save 25% compared to the individual plans</div></li><li><i class='bi bi-check-lg'></i><div>Access to the entire training catalog</div></li><li><i class='bi bi-check-lg'></i><div>Unlimited use of all digital tools, including AI</div></li>"
        },
        "pricing_card": {
          "year": "year",
          "month": "month",
          "buy_now": "Buy now",
          "checkout_error": "An error occurred while opening the checkout. Please try again later."
        }
      }
    }
  }
}
